import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../admin/admin.service';
import { RippleDirective } from '../ripple.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { DataToolsApps, DataToolsAppsTitles } from '../shared/DataToolsApps';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    RippleDirective,
    AsyncPipe,
    NgIf,
    MatTooltip
  ],
  templateUrl: './landing-page.html',
  styleUrls: ['./landing-page.scss']
})
export class LandingPageComponent implements OnInit {
  constructor(private adminService: AdminService, private router: Router) {
  }

  public DataToolsApps = DataToolsApps;
  public DataToolsAppsTitles = DataToolsAppsTitles;
  dataCleanerChecking$ = this.adminService.isAppChecking$(DataToolsApps.DATA_CLEANER);
  duplikitChecking$ = this.adminService.isAppChecking$(DataToolsApps.DUPLIKIT);
  dataRulesChecking$ = this.adminService.isAppChecking$(DataToolsApps.DATARULES);

  ngOnInit() {
  }

  appDisabled(pca: DataToolsApps): boolean {
    return !this.adminService.checkAppEnabled(pca);
  }

  goToApp(pca: DataToolsApps) {
    this.router.navigate([`/${pca.toString()}`]);
  }
}
